<template>
    <div class="priceSlider">
        <div class="priceSlider_box">
            <div class="content">
                <div class="pS_head pS_head-full ">
                    <button class="pS_head_link link_hovered " :class="{'active' : currentItemId == item.id}" v-for="item in sections" :key="item.id" @click="currentItemId=item.id">
                        {{ item.name }}
                    </button>
                </div>
            </div>
            <div class="content" v-for="item in sections" :key="item.id" v-show="!currentItemId || currentItemId == item.id">
                <product-slider :products="item.products"  ></product-slider>
            </div>
        </div>
    </div>
</template>
<script>
    import ProductSlider from "./ProductSlider";

    export default {
        name: 'ProductMultiSlider',
        components: {ProductSlider},
        props: ['sections'],
        data () {
            return {
                currentItemId: null
            }
        },
        mounted() {
            setTimeout(() => {
                this.currentItemId = this.sections[0].id
            }, 3000);

        }
    }
</script>

<style scoped>

</style>